define(["language/" + window.language + "/resource", "language/" + window.language + "/resourcehk", "authui/iamEnv"], function (i18n, i18nhk, iamEnv) {
    
    if (iamEnv.ipIsInternational()) {
        $.extend(i18n.framework, i18nhk.framework);
    }
    console.dir(i18n.framework);
    return i18n;
});


// WEBPACK FOOTER //
// ./public/hws/i18n/resource.js